<template>
  <modal name="enrollValidNotification" v-bind:width="400" v-bind:height="162" v-on:before-open="beforeOpen">
    <div class="enrollValidNotificationWrapper">
      <div class="enrollValidNotificationModalHeader">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="enrollValidNotificationModalContent">
        <span class="validText" >{{validText}}</span>
        <span class="validText" v-if="validText2 != null && validText2 !== ''"><br>{{validText2}}</span>
        <span class="smallValidText" v-if="validText3 != null && validText3 !== ''"><br>{{validText3}}</span>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      validText: null,
      validText2: null,
      validText3: null,
      closeIcon: null
    }
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('enrollValidNotification')
    },
    beforeOpen: function (event) {
      // 텍스트 셋팅
      this.validText = event.params.validText
      this.validText2 = event.params.validText2
      this.validText3 = event.params.validText3
    }
  },
  created: function () {
    this.closeIcon = require('@/assets/img/modal_close_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enrollValidNotificationWrapper{
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.enrollValidNotificationModalHeader{
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
}

.enrollValidNotificationModalHeader > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.enrollValidNotificationModalContent {
  text-align: center;
  height: 52px;
  padding: 30px 0 20px 0;
}

.validText {
  font-size: 17px;
}

.smallValidText {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollValidNotificationModal.vue